import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

const opt = {};

Vue.use(Vuetify);

export default new Vuetify(opt);
